export const enum FilterName {
  BRAND = "BrandPage",
  FLASH_SALE = "FlashSale",
  LOGGED_IN_CATEGORY = "Category",
  LOGGED_OUT_CATEGORY = "LoggedOutCategory",
  SUPPLIERS = "Suppliers",
  ORDERS = "Orders",
  SEARCH = "Search",
  UNKNOWN = "Unknown",
}
